import { useState } from 'react'
import useGrayScaleLogic from '../GrayScale/GrayScale.logic'
import { TrayType } from '../EditTrayModal/EditTrayModal.types'

const useTrayAnalysisContentLogic = ({
  selectedTrayType,
}: {
  selectedTrayType: TrayType
}) => {
  const {
    loadAllScrews,
    increaseAllPlatesBy,
    isAllScrewsLoaded,
    isAllPlatesLoaded,
    screwAnnotations,
    plateAnnotations,
    drillAnnotations,
  } = useGrayScaleLogic({ trayType: selectedTrayType })

  const [shouldShowGuide, setShouldShowGuide] = useState<boolean>(false)
  const [isCustomImplantModalOpen, setIsCustomImplantModalOpen] =
    useState<boolean>(false)

  const isCustomImplantTray = selectedTrayType === 'custom implants'

  const handleGuideClick = () => {
    setShouldShowGuide((prev) => !prev)
  }

  const handleCustomImplantModalTrigger = () => {
    setIsCustomImplantModalOpen((prev) => !prev)
  }

  return {
    shouldShowGuide,
    setShouldShowGuide,
    handleGuideClick,
    isCustomImplantModalOpen,
    setIsCustomImplantModalOpen,
    handleCustomImplantModalTrigger,
    isCustomImplantTray,
    loadAllScrews,
    increaseAllPlatesBy,
    isAllScrewsLoaded,
    isAllPlatesLoaded,
    screwAnnotations,
    plateAnnotations,
    drillAnnotations,
  }
}

export default useTrayAnalysisContentLogic
